var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-box"},[_c('div',{staticClass:"banner-list-box"},[_c('div',{staticClass:"item-box"},[_c('img',{attrs:{"src":require("../assets/banner/Welcome_to_TOZO_Community.png"),"alt":"Welcome to TOZO Community"}}),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('homePage.banner.Welcome')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }